import { useIntl } from 'react-intl'

import Typography from '../../../../../../components/Typography/Typography'
import './Screen.scss'

const Screen = () => {
    const intl = useIntl()

    return (
        <div className={'hall-screen'}>
            <div className="line"></div>
            <Typography variant={'sectionHeadline'}>{intl.formatMessage({ id: 'hall.screen' })}</Typography>
        </div>
    )
}

export default Screen
